import $ from '@nuskin/nuskinjquery';
import {UserService} from '@nuskin/ns-account';
import {getCachedConfigField} from '@nuskin/configuration-sdk';

const ThreatMatrixUtil = function() {
    'use strict';

    let $scope;
    let nsUtil;

    let threatMetrixScriptUrl;
    let sessionId;

    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------
    const publicMethods = {
        initThreatMatrixScriptUrl: function(scope, util) {
            $scope = scope;
            nsUtil = util;

            // Sample URL
            // https://img.nuskin.com/tags.js?org_id=if835g8d&pageid=1&session_id=71874ea4dec673fa92ab74a534a4467d

            threatMetrixScriptUrl = '{threatMetrixUrl}?org_id={orgId}&pageid={pageId}&session_id={sessionId}';
            threatMetrixScriptUrl = threatMetrixScriptUrl.replace('{threatMetrixUrl}', getCachedConfigField('threatMetrixUrl'));
            threatMetrixScriptUrl = threatMetrixScriptUrl.replace('{orgId}', getCachedConfigField('orgId'));
            threatMetrixScriptUrl = threatMetrixScriptUrl.replace('{pageId}', getCachedConfigField('pageId'));

            setSessionId(); // Hit a service for this one.
        },
        getSessionId: function() {
            return sessionId;
        }
    };

    // ---------------------------------------------
    //
    //        Private Methods
    //
    // ---------------------------------------------

    /**
     * setCustomOrder
     */
    function setCustomOrder() {
        // Update the order.
        $scope.order.custom = [{Key: 'METRIX', Value: sessionId, Type: ''}];
    }

    /**
     * setSessionId
     */
    function setSessionId() {
        if (sessionId) {
            setCustomOrder();
        } else {
            const user = UserService.getUser();

            if (user && !nsUtil.isEmpty(user.id)) {
                let url = '/apps/shop/services/threatMetrix?userId={userId}';
                url = url.replace('{userId}', user.id);

                $.ajax({
                    type: 'GET',
                    url: url,
                    dataType: 'text',
                    success: function(newSessionId) {
                        // Remove any carriage returns and new lines.
                        newSessionId = newSessionId.split('\n').join('');
                        newSessionId = newSessionId.split('\r').join('');

                        threatMetrixScriptUrl = threatMetrixScriptUrl.replace('{sessionId}', newSessionId);

                        // The script below will get executed but will not display in the DOM after it is appended.
                        const script = '<script src="' + threatMetrixScriptUrl + '"></script>';
                        $('head').append(script);
                        sessionId = newSessionId;
                        setCustomOrder();
                    },
                    error: function(/* xhr*/) {
                        console.log('Failed getting session id for threat metrix.');
                    }
                });
            }
        }
    }

    return publicMethods;
}();

export default ThreatMatrixUtil;
